import React, { useEffect, useMemo } from 'react';
import ReactDOM from 'react-dom';

const CONTEXT_MENU_Z_INDEX = 3000;

interface ContextMenuPortalProps {
  children: React.ReactNode;
  x: number;
  y: number;
}

/**
 * A portal to render the context menu at the root of the document body.
 * This ensures the menu is not clipped by parent containers with overflow: hidden.
 */
export const ContextMenuPortal: React.FC<ContextMenuPortalProps> = ({
  children,
  x,
  y,
}) => {
  const portalRoot = document.body;
  // useMemo ensures the element is created only once per component instance.
  const container = useMemo(() => document.createElement('div'), []);

  useEffect(() => {
    portalRoot.appendChild(container);
    return () => {
      portalRoot.removeChild(container);
    };
  }, [container, portalRoot]);

  return ReactDOM.createPortal(
    <div style={{ position: 'fixed', top: y, left: x, zIndex: CONTEXT_MENU_Z_INDEX }}>
      {children}
    </div>,
    container,
  );
};

 